<template>
  <div class="step" :class="customClass">
    <div class="align-items-center d-flex justify-content-start step__header">
      <div class="step__number mb-1">
        <span class="step__number__count" v-html="step"></span>
      </div>
      <div class="step__details">
        <h4 class="mb-1 step__title text-dark" v-html="title"></h4>
        <p class="mb-0 step__sub-title subtle-text" v-html="subTitle"></p>
      </div>
    </div>

    <!-- This is where the content of the step will be rendered -->
    <div class="ml-5">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Step',
    props: {
      customClass: {
        required: false
      },
      step: {
        required: false
      },
      subTitle: {
        required: false
      },
      title: {
        required: false
      }
    }
  }
</script>

<style lang="scss">
  @import "../styles/theme";

  .step__number {
    height: 15px;
    width: 15px;

    margin-right: 35px;
  }

  .step__number__count {
    border: 1px solid $text-subtle;
    border-radius: 50%;

    height: 100%;
    width: 100%;

    margin-bottom: $wizard-step-gap;
    margin-right: 1rem;
    padding: 55% 95%;
  }

  h4.step__title {
    font-size: 21px;
  }

  .step__sub-title {
    color: $text-subtle;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Step.vue